import { FGStack, FGTypography } from '@fg/design-system';
import { IActiveCountryMap } from 'interfaces';
import { isEmpty, map } from 'lodash/fp';
import React from 'react';
import rootStore from 'RootStore';

type Props = {
    selectedCountries?: number[];
    licencedCountries?: IActiveCountryMap;
};

export const SortLegendCountries = React.memo(
    ({ selectedCountries, licencedCountries }: Props) => {
        if (isEmpty(selectedCountries)) {
            return null;
        }
        return (
            // React.Fragment is used to keep the parent flex-wrap wrapping multiline correctly
            <React.Fragment>
                <div
                    style={{
                        marginInline: 24,
                        fontSize: 8,
                        color: 'var(fg-color-border);',
                    }}>
                    |
                </div>
                {map(countryId => {
                    return (
                        <FGStack
                            alignItems="center"
                            // the legend container (which also includes the initial circles) has a 8px gap,
                            // but the countries should have 16px gap
                            style={{ marginRight: 8 }}
                            key={countryId}
                            gap={8}>
                            <LegendCircle
                                radius={12}
                                bg={rootStore.countryStore.colorStack.color(
                                    countryId
                                )}
                            />
                            <FGTypography
                                variant="captions"
                                tag="label"
                                color="strong">
                                {licencedCountries[countryId]?.name}
                            </FGTypography>
                        </FGStack>
                    );
                }, selectedCountries)}
            </React.Fragment>
        );
    }
);

export const LegendCircle = React.memo(({ radius, bg }: { radius: number; bg?: string }) => {
    return (
        <div
            style={{
                width: radius,
                height: radius,
                borderRadius: '50%',
                backgroundColor: bg || 'var(--fg-color-surface-selected)',
            }}
        />
    );
});

export const LegendLabel = React.memo(
    ({ children }: { children: React.ReactNode }) => {
        return (
            <FGTypography variant="captions" tag="label" color="strong">
                {children}
            </FGTypography>
        );
    }
);